module["exports"] = [
  "#{Address.city_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/address/city.js
 ** module id = 901
 ** module chunks = 0
 **/